import React from 'react';

import type { RouteObject } from 'react-router-dom';

const Settings = React.lazy(() => import('./SettingsLayout'));
const SettingsDefault = React.lazy(() => import('./pages/SettingsDefault'));
const Activities = React.lazy(() => import('./pages/Activities'));
const Watch = React.lazy(() => import('./pages/Watch'));
const Tablet = React.lazy(() => import('./pages/Tablet'));
const Actions = React.lazy(() => import('./pages/Actions'));
const WorkingHours = React.lazy(() => import('./pages/WorkingHours'));
const OtherSettings = React.lazy(() => import('./pages/OtherSettings'));
const Tasks = React.lazy(() => import('./pages/Tasks'));
const Automation = React.lazy(() => import('./pages/Automation'));

const suspense = (el: React.ReactNode) => {
	return <React.Suspense fallback={null}>{el}</React.Suspense>;
};

export const organizationSettingsRoutes: RouteObject = {
	path: 'settings',
	element: suspense(<Settings />),
	children: [
		{
			index: true,
			element: suspense(<SettingsDefault />),
		},
		{
			path: 'shift-planner/activities',
			element: suspense(<Activities />),
		},
		{
			path: 'shift-planner/working-hours',
			element: suspense(<WorkingHours />),
		},
		{
			path: 'shift-planner/other-settings',
			element: suspense(<OtherSettings />),
		},
		{
			path: 'device-settings/watch',
			element: suspense(<Watch />),
		},
		{
			path: 'device-settings/tablet',
			element: suspense(<Tablet />),
		},
		{
			path: 'messaging/actions',
			element: suspense(<Actions />),
		},
		{
			path: 'messaging/tasks',
			element: suspense(<Tasks />),
		},
		{
			path: 'automation/multiple-presses',
			element: suspense(<Automation />),
		},
	],
};
